/* eslint-disable no-param-reassign */
import {
  glassesNeedingPrescription,
  ProductTypesInfo,
  ShopifyProductTypes,
} from '../config/settings';
import { OrderItem, Prescription, Product, ShopifyPredictiveSearch, ShopifyProduct } from './types';

const placeholderProduct: Product = {
  id: null,
  title: '',
  description: '',
  type: '',
  price: null,
  variants: [],
};

export const shopifyProdToProduct = (shopifyProduct: ShopifyProduct | undefined): Product => {
  if (!shopifyProduct) return placeholderProduct;
  const product: Product = {
    id: shopifyProduct.id,
    handle: shopifyProduct.handle,
    title: shopifyProduct.title,
    description: shopifyProduct.description,
    price: shopifyProduct.price,
    variants: shopifyProduct.variants,
    type: shopifyProduct.type,
  };
  if (shopifyProduct.properties) product.properties = shopifyProduct.properties;
  return product;
};

export const getDefaultVariantId = ({ variants }: Product): number => {
  if (variants.length === 0) return 0;
  const id: number = +variants[0].id;
  return id;
};

export const productToOrderItem = (variantId: number, quantity: number): OrderItem => {
  return {
    id: variantId,
    quantity,
  };
};

export const shopifyPredictiveSearchToProductHandles = (
  data: ShopifyPredictiveSearch | undefined,
  parentType: string,
  type: string,
  needsPrescription: boolean = false
): string[] => {
  const products =
    data?.resources.results.products.filter(
      (prod) => prod.type === type && !prod.tags.includes('hidden')
    ) || [];
  const handles = products.map((prod) => prod.handle);

  const exclude = needsPrescription
    ? typeToExludedWhenPrescriptionNeededProducts(parentType)
    : typeToExludedProducts(parentType);
  return handles.filter((handle) => !exclude.includes(handle)).sort((a, b) => b.length - a.length);
};

export const typeToExludedProducts = (type: string): string[] => {
  const exclude = ProductTypesInfo.find((x) => x.type === type)?.exclude;
  return exclude || [];
};

export const typeToExludedWhenPrescriptionNeededProducts = (type: string): string[] => {
  const exclude = ProductTypesInfo.find((x) => x.type === type)?.excludeWhenPrescriptionNeeded;
  return exclude || [];
};

export const typeToLastStep = (type: string, glasses: Product | null): number => {
  if (type === ShopifyProductTypes.SUNGLASSES) return 2;
  if (!glassesNeedingPrescription.includes(glasses?.id || 0)) return 0;
  return 2;
};

export const populateMainItemProperties = ({
  mainItem,
  glasses,
  upsells,
  glassExtra,
  prescription,
}: {
  mainItem: OrderItem;
  glasses: Product;
  upsells: Product[];
  glassExtra: Product | null;
  prescription: Prescription;
}): void => {
  if (glasses.id && glassesNeedingPrescription.includes(glasses.id)) {
    mainItem.properties = {
      glasses: getDefaultVariantId(glasses),
      prescription:
        prescription.data !== '' ? JSON.stringify(prescription.data) : prescription.title,
    };
    if (glassExtra) {
      mainItem.properties = {
        ...mainItem.properties,
        prep: getDefaultVariantId(glassExtra),
      };
    }
  }
  if (upsells.length > 0) {
    mainItem.properties = {
      ...mainItem.properties,
      upsells: upsells.map((product) => getDefaultVariantId(product)),
    };
  }
};
